import React from "react";
import { DynamicTable } from "@maherunlocker/custom-react-table";
import { CardBody } from "reactstrap";
import { PlusIcon } from "@aureskonnect/react-ui";
import classnames from "classnames";

import { ConfirmationUpdatingDataMessageModal } from "@components/Common/ConfirmationUpdatingDataMessageModal";
import { AlertDeletePeripheralMessage } from "@components/Common/AlertDeletePeripheralMessage";
import { ConfirmationDeleteMessage } from "@components/Common/ConfirmationDeleteMessage";
import { ConfirmationInitializationMessage } from "@components/Common/ConfirmationInitializationMessage";
import { CustomMainColorIconButton } from "@components/Common/CustomMainColorIconButton";
import { ConfirmationMessageEditPeripheral } from "@components/Common/ConfirmationMessageEditPeripheral";
import { CustomMainColorButtonWithIcon } from "@components/Common/CustomMainColorButtonWithIcon";

import MoneticsApplicationForm from "./MoneticsApplicationForm/";
import PrepheralCardFooter from "./PrepheralCardFooter";

import { useMonetics } from "./useMonetics";
import { PERIPHERAL_FORM_CARD_STYLE } from "./styles";

import "./index.css";

type DeviceAssociateModalType = {
    setIsDeviceAssociateModalOpened: Function;
    isDeviceAssociateModalOpened: boolean;
    rowData: any;
    dataIsUpdated: boolean | number;
    setDataIsUpdated: Function;
    selectedRows: any;
};

export function Monetics({
    setIsDeviceAssociateModalOpened,
    isDeviceAssociateModalOpened,
    rowData,
    dataIsUpdated,
    setDataIsUpdated,
    selectedRows,
}: DeviceAssociateModalType) {
    const {
        t,
        getAuthHeader,
        oneShop,
        userID,
        franchiseID,
        shopID,
        isAddPeripheralClicked,
        setIsAddPeripheralClicked,
        isActionsClicked,
        actions,
        validationAction,
        isEdited,
        setIsEdited,
        shopId,
        modify,
        isAddNewMoneticsButtonClicked,
        setIsAddNewMoneticsButtonClicked,
        isModalOpened,
        setIsModalOpened,
        data,
        setData,
        isConfirmationEditRunning,
        setIsConfirmationEditRunning,
        isInInitializationModalOpened,
        setIsInInitializationModalOpened,
        i18nextLng,
        editedData,
        setEditedData,
        moneticId,
        dataMoneticIsUpdated,
        setDataMoneticIsUpdated,
        filterActive,
        setLocalFilterActive,
        isModalDeleteAssociatePeripheralOpened,
        setIsModalDeleteAssociatePeripheralOpened,
        selectMark,
        setSelectMark,
        inputDesignation,
        setInputDesignation,
        InputIp,
        setInputIp,
        ipExist,
        setIpExist,
        setIsUpdateOperation,
        arrayOfCustomColumns,
        customJsxComponent,
        applications,
        setIsActionsClicked,
    } = useMonetics({ rowData, selectedRows });

    const validSelectedRows = selectedRows.filter(
        (elt: any) => elt[t("Application")] !== ""
    );
    const resolvedShopId = oneShop
        ? shopID
        : validSelectedRows.length > 0
        ? validSelectedRows[0].shopId
        : rowData.shopId;

    return (
        <React.Fragment>
            <CardBody className="p-1" style={PERIPHERAL_FORM_CARD_STYLE}>
                <div
                    style={{
                        display: "grid",
                        minHeight: "650px",
                        gridTemplateColumns: isAddPeripheralClicked
                            ? "2fr 1fr "
                            : "auto",
                        gridColumnGap: "4px",
                        marginBottom: isAddPeripheralClicked ? "70px" : "0px",
                        border: 0,
                    }}
                >
                    <DynamicTable
                        requestHeader={{
                            "Accept-Language": i18nextLng,
                            ...getAuthHeader,
                        }}
                        url={`${process.env.REACT_APP_API_V2_URL}/settings/monetics?userId=${userID}&shopId=${resolvedShopId}&franchiseId=${franchiseID}&typeDisplay=notArchived`}
                        showGlobalFilter
                        filterActive={filterActive}
                        setDataIsUpdated={setDataMoneticIsUpdated}
                        dataIsUpdated={dataMoneticIsUpdated}
                        setLocalFilterActive={setLocalFilterActive}
                        arrayOfCustomColumns={arrayOfCustomColumns}
                        actionColumn={customJsxComponent}
                        minHeight="520px"
                        maxHeight="520px"
                        setData={setData}
                        customJsxSideFilterButton={
                            !isAddPeripheralClicked && modify ? (
                                <div className="d-flex justify-content-start align-items-center">
                                    <span
                                        onClick={() => {
                                            setEditedData([]);
                                            setIsAddPeripheralClicked(
                                                !isAddPeripheralClicked
                                            );
                                        }}
                                        className={`${classnames(
                                            "afa_btn_addPeripheral",
                                            {
                                                "not-allowed-icon__clz":
                                                    applications.length > 1,
                                            }
                                        )}`}
                                    >
                                        <CustomMainColorButtonWithIcon
                                            icon="PlusIcon"
                                            iconPosition="left"
                                            className="w-100"
                                            rounded
                                            style={{ height: "0px" }}
                                            variant="primary"
                                        >
                                            {t("Add device")}
                                        </CustomMainColorButtonWithIcon>
                                    </span>
                                </div>
                            ) : modify ? (
                                <div className="d-flex justify-content-start">
                                    <CustomMainColorIconButton
                                        icon="PlusIcon"
                                        rounded
                                        disabled={editedData.length !== 0}
                                        onClick={() => {
                                            if (isEdited)
                                                setIsInInitializationModalOpened(
                                                    true
                                                );
                                            else {
                                                setInputDesignation(false);
                                                setSelectMark(false);
                                            }
                                        }}
                                    >
                                        <PlusIcon
                                            height={20}
                                            width={20}
                                            fill="white"
                                        />
                                    </CustomMainColorIconButton>
                                </div>
                            ) : null
                        }
                    />
                    {isAddPeripheralClicked ? (
                        <MoneticsApplicationForm
                            isAddMoneticsClicked={isAddPeripheralClicked}
                            setIsAddMoneticsClicked={setIsAddPeripheralClicked}
                            idShop={
                                validSelectedRows.length > 0
                                    ? validSelectedRows[0].shopId
                                    : rowData.shopId
                            }
                            setDataIsUpdated={setDataMoneticIsUpdated}
                            setIsAddNewMoneticsButtonClicked={
                                setIsAddNewMoneticsButtonClicked
                            }
                            isAddNewMoneticsButtonClicked={
                                isAddNewMoneticsButtonClicked
                            }
                            setEditedData={setEditedData}
                            editedData={editedData}
                            isEdited={isEdited}
                            setIsEdited={setIsEdited}
                            selectMark={selectMark}
                            setSelectMark={setSelectMark}
                            inputDesignation={inputDesignation}
                            setInputDesignation={setInputDesignation}
                            InputIp={InputIp}
                            setInputIp={setInputIp}
                            tableData={data}
                            shopIds={[shopId]}
                            setIsUpdateOperation={setIsUpdateOperation}
                            setIpExist={setIpExist}
                            ipExist={ipExist}
                            isConsult={false}
                            setIsConsult={() => {}}
                            selectedRows={selectedRows}
                            isModalAssociate={true}
                        />
                    ) : null}
                </div>
                {!isModalDeleteAssociatePeripheralOpened ? (
                    <ConfirmationDeleteMessage
                        text={t("Please confirm deletion of this device")}
                        isModalOpened={isModalOpened}
                        setIsModalOpened={setIsModalOpened}
                        setDataIsUpdated={setDataMoneticIsUpdated}
                        apiUrl={`${process.env.REACT_APP_API_V2_URL}/settings/monetics?userId=${userID}&shopId=${shopId}&franchiseId=${franchiseID}&id=${moneticId}&isArchived=true`}
                        data={{
                            userId: userID,
                            shopId: shopId,
                            franchiseId: franchiseID,
                        }}
                        message={t("The device was successfully removed")}
                        setGlobalDataIsUpdated={setDataIsUpdated}
                    />
                ) : (
                    <AlertDeletePeripheralMessage
                        text={t(
                            "This device is associated with one or more applications! Unable to perform delete action"
                        )}
                        isModalDeleteAssociatePeripheralOpened={
                            isModalDeleteAssociatePeripheralOpened
                        }
                        setIsModalDeleteAssociatePeripheralOpened={
                            setIsModalDeleteAssociatePeripheralOpened
                        }
                    />
                )}

                {isInInitializationModalOpened ? (
                    <ConfirmationInitializationMessage
                        isModalOpened={isInInitializationModalOpened}
                        setIsModalOpened={setIsInInitializationModalOpened}
                        setIsClicked={setIsAddNewMoneticsButtonClicked}
                        isClicked={isAddNewMoneticsButtonClicked}
                        setIsEdited={setIsEdited}
                    />
                ) : null}
            </CardBody>
            {!isAddPeripheralClicked ? (
                <PrepheralCardFooter
                    dataIsUpdated={dataIsUpdated}
                    setIsEdited={setIsEdited}
                    setIsDeviceAssociateModalOpened={
                        setIsDeviceAssociateModalOpened
                    }
                    isDeviceAssociateModalOpened={isDeviceAssociateModalOpened}
                    rowData={rowData}
                    setDataIsUpdated={setDataIsUpdated}
                    selectedRows={selectedRows}
                />
            ) : null}
            {isConfirmationEditRunning ? (
                <ConfirmationMessageEditPeripheral
                    isModalOpened={isConfirmationEditRunning}
                    setIsModalOpened={setIsConfirmationEditRunning}
                    setCancel={setIsAddPeripheralClicked}
                    archive={false}
                />
            ) : null}
            {isActionsClicked ? (
                <ConfirmationUpdatingDataMessageModal
                    isModalOpened={isActionsClicked}
                    setIsEdited={setIsEdited}
                    setIsModalOpened={setIsActionsClicked}
                    validationAction={validationAction}
                    actions={actions}
                />
            ) : null}
        </React.Fragment>
    );
}
